var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as _ from 'lodash';
import { UIComponent, childrenExist, customPropTypes, commonPropTypes, } from '../../lib';
import FormField from './FormField';
/**
 * A Form displays a set of related user input fields in a structured way.
 * @accessibility
 * Label needs to be provided by using 'aria-label', or 'aria-labelledby' attributes on the <form> element.
 */
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSubmit = function (e) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var action = _this.props.action;
            // Heads up! Third party libs can pass own data as first argument, we need to check that it has preventDefault()
            // method.
            if (!action)
                _.invoke(e, 'preventDefault');
            _.invoke.apply(_, [_this.props, 'onSubmit', e, _this.props].concat(args));
        };
        _this.renderFields = function () {
            var fields = _this.props.fields;
            return _.map(fields, function (field) { return FormField.create(field); });
        };
        return _this;
    }
    Form.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, rest = _a.rest;
        var _b = this.props, action = _b.action, children = _b.children;
        return (React.createElement(ElementType, __assign({ className: classes.root, action: action, onSubmit: this.handleSubmit }, rest), childrenExist(children) ? children : this.renderFields()));
    };
    Form.displayName = 'Form';
    Form.className = 'ui-form';
    Form.propTypes = __assign({}, commonPropTypes.createCommon({
        content: false,
    }), { action: PropTypes.string, fields: customPropTypes.collectionShorthand, onSubmit: PropTypes.func });
    Form.defaultProps = {
        as: 'form',
    };
    Form.Field = FormField;
    return Form;
}(UIComponent));
export default Form;
